import React, { useMemo } from "react";

import { Icon, StatusText } from "shared/styles";
import { ITheme, IStatus } from "shared/types";
import { ACTION_DROPDOWN_TYPE } from "shared/components";

import {
  StyledActionDropdownItem,
  StyledActionDropdownItemProps,
  StyledActionDropdownLink,
} from "../styles";
import { colors, VisuallyHiddenElement } from "shared/styles/constants";
import { Checkmark } from "shared/assets/icons";

export interface IActionDropdownItem {
  type?: ACTION_DROPDOWN_TYPE.ITEM;
  label: string | JSX.Element;
  icon?: React.ComponentType<any>;
  handleClick: () => void;
  status?: IStatus;
  dataTestId?: string;
  theme?: ITheme.primary | ITheme.secondary;
  isSelected?: boolean;
  to?: string;
  quickAction?: boolean;
  note?: string;
}

interface ActionDropdownItemProps
  extends IActionDropdownItem,
    StyledActionDropdownItemProps {}

export const ActionDropdownItem: React.FC<ActionDropdownItemProps> = ({
  label,
  handleClick,
  status,
  wrapOptions,
  dataTestId,
  theme,
  isSelected,
  to,
}) => {
  const content = useMemo(
    () => (
      <>
        <StatusText status={status}>{label}</StatusText>
        {isSelected && (
          <>
            <Icon as={Checkmark} color={colors.green} />
            <VisuallyHiddenElement>Selected</VisuallyHiddenElement>
          </>
        )}
      </>
    ),
    [isSelected, label, status]
  );

  if (to) {
    return (
      <StyledActionDropdownLink
        to={to}
        data-testid={dataTestId}
        wrapOptions={wrapOptions}
        theme={theme}
        onClick={handleClick}
      >
        {content}
      </StyledActionDropdownLink>
    );
  }

  return (
    <StyledActionDropdownItem
      type="button"
      onClick={handleClick}
      data-testid={dataTestId}
      wrapOptions={wrapOptions}
      theme={theme}
    >
      {content}
    </StyledActionDropdownItem>
  );
};
